module.exports = __webpack_public_path__ + "static/inhale-exhale-explode_2010-2bfec91bb76cc96827900456f7898765.jpg";